/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum SubscriptionStatus {
  Active = 1,
  Suspended = 2,
  Cancelled = 99,
}
